// Root.js
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "./features/auth/authSlice";
import internetloss from "./assets/img/internet2.jpg";
import Header from "./layout/Header";
import { baseURLRef, getSubdomain } from "./utils";
import { setSubdomain } from "./features/global/globalSlice";
import { domainColours } from "./components/DomainColours";
import axiosInstance from "./instance";
import { useEffect, useState } from "react";

export default function Root() {
  const { isActive } = useSelector((state) => state.auth);
  const token = localStorage.getItem("token");
  const { subdomain } = useSelector((state) => state.global);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loc = useLocation();
 

  useEffect(() => {
    // Public routes that don't require authentication
    const publicRoutes = [
      "/",
      "/landing",
      "/login",
      "/login-password",
      "/login-otp",
      "/select-organization",
      "/registration",
      "/registration-success",
      "/forgot-password",
      "/verify-email",
      "/new-password",
      "/password-reset-success",
      "/kyu-documents",
      "/kyb-documents", 
    ];

    // Check if current path is public
    const isPublicRoute = publicRoutes?.includes(loc?.pathname);

    if (!token && !isPublicRoute) {
      dispatch(logout());
      navigate("/login");
    }
  }, [token, dispatch, navigate, loc.pathname]);

  // Route restriction for ndovupay.org domain - only allow /landing
  useEffect(() => {
    const hostname = window.location.hostname;
    const isNdovupayOrg = hostname === "ndovupay.org" || hostname === "www.ndovupay.org";

    if (isNdovupayOrg && loc.pathname !== "/landing" && loc.pathname !== "/") {
      navigate("/landing", { replace: true });
    }
  }, [loc.pathname, navigate]);

  useEffect(() => {
    const sub = getSubdomain();
    dispatch(setSubdomain(sub));

    const colour = domainColours[sub] ?? "#0049B3";
    document?.documentElement?.style?.setProperty("--btn-bg", colour);
  }, []);

  const [baseURL, setBaseURL] = useState(baseURLRef?.current);
  useEffect(() => {
    if (subdomain === "bovepay") {
      baseURLRef.current = process.env.REACT_APP_API_BASE_URL_BOVEPAY;
    } else if (subdomain === "ndovupay" || subdomain === "localhost") {
      baseURLRef.current = process.env.REACT_APP_API_BASE_URL_NDOVUPAY;
    } else {
      baseURLRef.current = process.env.REACT_APP_API_BASE_URL;
    }
    axiosInstance.defaults.baseURL = baseURLRef?.current;
    setBaseURL(baseURLRef?.current);
  }, [subdomain]);

  if (!navigator.onLine) {
    return (
      <div className="w-full h-full overflow-y-scroll">
        <div className="flex flex-col items-center justify-center text-center py-0 lg:px-[50px] mx-[50px]">
          <h1 className="text-red font-[700]">Oops! Something went wrong...</h1>
          <p>You appear to be offline. Turn on your Wi-Fi to continue</p>
          <img src={internetloss} className="object-cover w-full h-full" />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col w-full"> 
      {isActive && 
       loc?.pathname !== "/" && 
       loc?.pathname !== "/choose-screen" && 
       <Header />}

      <div className="flex flex-col items-start w-full h-full">
        <Outlet />
      </div>
    </div>
  );
}